import NormalMd2React from './NormalMd2React';

const Md2React = {
	Normal: NormalMd2React,
};

export default Md2React;
